import React from 'react';
import { Card } from '@/components/ui/card';
import { ArrowUp, ArrowDown } from 'lucide-react';

export const StatCard = ({ title, value, icon: Icon, trend, trendDirection, color = 'emerald' }) => {
  const colorClasses = {
    emerald: 'text-emerald-600 bg-emerald-50',
    violet: 'text-violet-600 bg-violet-50',
    blue: 'text-blue-600 bg-blue-50',
    purple: 'text-purple-600 bg-purple-50',
    amber: 'text-amber-600 bg-amber-50',
  };

  return (
    <Card className="p-6 relative overflow-hidden transition-all duration-200 hover:shadow-md" data-testid={`stat-card-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-slate-600 mb-1">{title}</p>
          <h3 className="text-3xl font-bold text-slate-900 mb-2">{value}</h3>
          {trend !== undefined && (
            <div className="flex items-center gap-1">
              {trendDirection === 'up' ? (
                <ArrowUp className="w-4 h-4 text-emerald-600" />
              ) : (
                <ArrowDown className="w-4 h-4 text-red-600" />
              )}
              <span className={`text-sm font-medium ${
                trendDirection === 'up' ? 'text-emerald-600' : 'text-red-600'
              }`}>
                {trend}%
              </span>
            </div>
          )}
        </div>
        <div className={`p-3 rounded-lg ${colorClasses[color] || colorClasses.emerald}`}>
          <Icon className="w-6 h-6" strokeWidth={1.5} />
        </div>
      </div>
    </Card>
  );
};
